import React from "react";
import { Users, X } from "lucide-react";

export default function ModalHeader({ onClose }) {
  return (
    <div className="flex items-start justify-between gap-4 px-6 py-5 sm:px-8 sm:py-6 border-b border-slate-100">
      <div className="flex items-start gap-4">
        <div className="flex h-10 w-10 flex-none items-center justify-center rounded-xl bg-primary/10 ring-1 ring-primary/20">
          <Users className="h-5 w-5 text-primary" aria-hidden="true" />
        </div>
        <div>
          <h2
            id="lead-owners-modal-title"
            className="font-sans text-base font-semibold text-slate-900 tracking-tight"
          >
            Lead Owners
          </h2>
          <p className="mt-1 max-w-md font-sans text-xs sm:text-sm leading-relaxed text-slate-500">
            Assign one or more owners to each workflow stage. Multiple owners
            can be responsible for the same stage.
          </p>
        </div>
      </div>

      <button
        type="button"
        onClick={onClose}
        aria-label="Close"
        className="flex-none rounded-lg p-1.5 text-slate-400 transition-all duration-200 hover:bg-slate-50 hover:text-slate-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
      >
        <X className="h-4 w-4" aria-hidden="true" />
      </button>
    </div>
  );
}